import React from "react";
import Styles from "./MobileInputHeader.module.scss";
//
import Helpdesk from "../../company-registration-form/Helpdesk/Helpdesk";
import { ModalCrossIcon } from "@vahak/core-ui/dist/components/Modal/Modal";
//
import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";
//
import { IDs } from "@vahak/core/dist/constants/automation";

import COLORS from "@vahak/core-ui/dist/constants/colors";
import { getAllVwoABTestVariations } from "../../../../methods/getABTestVariation";
import { AB_TEST_CAMPAIGN_IDS } from "../../../../constants/abTestVariations";

interface MobileInputHeaderProps {
    type: "phone-input" | "otp-input";
    onCloseModal: () => void;
    toggleCallBackRequestModal?: () => void;
}
const MobileInputHeader = ({ type, onCloseModal, toggleCallBackRequestModal }: MobileInputHeaderProps) => {
    const isMobileScreen = useMediaQuery({ queryType: "mobile" });
    const { abTestVariations }: any = getAllVwoABTestVariations();
    const ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
    const downloadAppTestCampaign =
        ENV === "production" ? AB_TEST_CAMPAIGN_IDS["downloadAppProd"] : AB_TEST_CAMPAIGN_IDS["downloadApp"];

    const getHeaderBasedOnScreen = () => {
        switch (type) {
            case "phone-input": {
                return (
                    <div className={Styles.header}>
                        <div className={Styles.actionWrapper}>
                            <div className={Styles.titleText}>
                                Business Karo
                                <br />
                                Bharose ke sath!
                            </div>
                            <Helpdesk
                                bgColor={isMobileScreen ? "transparent" : COLORS.GREY_200}
                                onClick={toggleCallBackRequestModal}
                            />
                        </div>
                        {abTestVariations[downloadAppTestCampaign] !== 3 ? (
                            <ModalCrossIcon onClick={onCloseModal} id={IDs.auth.crossBtn} />
                        ) : (
                            <></>
                        )}
                    </div>
                );
            }
            case "otp-input": {
                return (
                    <div className={Styles.header}>
                        <div className={Styles.actionWrapper} />
                        {abTestVariations[downloadAppTestCampaign] !== 3 ? (
                            <ModalCrossIcon onClick={onCloseModal} id={IDs.auth.crossBtn} />
                        ) : (
                            <></>
                        )}
                    </div>
                );
            }
        }
    };
    return <div className={Styles.main}>{getHeaderBasedOnScreen()}</div>;
};

export default MobileInputHeader;
